import React, {useEffect, useState} from 'react'
import {inject, observer} from 'mobx-react'
import MonitorItem from '@components/monitorItem'
import {getMediaWallProgram, getMonitorList, playMediaWallProgram} from '@apis'
import lightBtnVideoBg from '@assets/img/lightBtnVideoBg.png'
import mapBg1 from '@assets/img/mapBg1.png'
import lightChoose from '@assets/img/lightChoose.png'
import lightJump from '@assets/img/lightJump.png'
import defaultPicture from '@assets/img/defaultPicture.png'
import AddProgram from './add-program'
import './index.less'

let swiper = null
let interval
let timeout

function repairNum(num) {
  if (num < 10) {
    return `0${num}`
  }
  return num
}

// 灯光秀控制
const CockpitLightControl = inject('store')(
  observer(({store}) => {
    const {userInfo = {}} = store
    const {brokerId} = userInfo

    const [pgShowList, setPgShowList] = useState([])
    const [pgList, setPgList] = useState([])
    const [monitorList, setMonitorList] = useState([])
    const [currentPlayPgIndex, setCurrentPlayPgIndex] = useState(null)
    const [centerVideo, setCenterVideo] = useState()
    const [leftVideo, setLeftVideo] = useState()
    const [rightVideo, setRightVideo] = useState()
    const [addProgramVisible, setAddProgramVisible] = useState(false)
    const [playType, setPlayType] = useState(null)

    // 查询节目列表
    async function getProgramList() {
      const params = {
        pageNo: 1,
        pageSize: 9999,
        brokerId,
      }
      const res = await getMediaWallProgram(params)
      if (res && res.data) {
        setPgList(res.data)
        const result = res.data.filter(one => one.dataBigscreenDisplay === 1).map(item => {
          let videoList = []
          item.programBillMediaWallInstanceDTOList.forEach(one => {
            videoList = videoList.concat(one.videoInstanceDTOList)
          })
          const result = {
            ...item,
            videoList
          }
          return result
        })
        setPgShowList(result)
        videoLoad(result)
        result.map((item,i) => {
          if(item.playStatus == 1) {
            setCenterVideo(JSON.parse(item.bindSpecialSource)[0])
            setLeftVideo(JSON.parse(item.bindSpecialSource)[1] ? JSON.parse(item.bindSpecialSource)[1] : null)
            setRightVideo(JSON.parse(item.bindSpecialSource)[2] ? JSON.parse(item.bindSpecialSource)[2] : null)
            setCurrentPlayPgIndex(i)
            setPlayType(i)
            videoMuted()
          }
        })
      }
    }

    async function queryMonitorList() {
      const params = {
        brokerId,
        pageNo: 1,
        pageSize: 9999,
      }
      const res = await getMonitorList(params)
      if (res && res.data) {
        setMonitorList(res.data)
      }
    }

    // 视频静音
    function videoMuted() {
      interval = setInterval(() => {
        for(let i=0; i<document.getElementsByTagName('video').length; i++) {
          document.getElementsByTagName('video')[i].muted = true
        }
      }, 50)
      timeout = setTimeout(() => {
        clearInterval(interval)
      }, 3000)
    }

    // 单击某个节目开始播放
    async function playpro(index, record, playStatus) {
      clearInterval(interval)
      clearTimeout(timeout)
      const params = {
        programId: record.id,
        playStatus,
        programType: 1
      }
      const res = await playMediaWallProgram(params)
      if(playStatus) {
        for(let i=0; i<document.getElementsByTagName('video').length; i++) {
          document.getElementsByTagName('video')[i].play()
        }
        setCurrentPlayPgIndex(index)
      }
      setPlayType(index)
      setCenterVideo(JSON.parse(record.bindSpecialSource)[0])
      setLeftVideo(JSON.parse(record.bindSpecialSource)[1])
      setRightVideo(JSON.parse(record.bindSpecialSource)[2])
      videoMuted()
    }

    // 视频预加载
    function videoLoad(res) {
      let video = new Array()
      res.map((item, i) => {
        if(item.bindSpecialSource.split('http')[0] == "") {
          video[i] = document.createElement('video')
          video[i].setAttribute('src', item.bindSpecialSource)
          video[i].load()
        }
      })
    }

    function pausePlatPg(index, item) {
      for(let i=0; i<document.getElementsByTagName('video').length; i++) {
        document.getElementsByTagName('video')[i].pause()
      }
      setCurrentPlayPgIndex(null)
      playpro(index, item, 0)
    }

    useEffect(() => {
      getProgramList()
      queryMonitorList()
      setTimeout(() => {
        swiper = new Swiper(".mySwiper", {
          loop: true,
          slidesPerView: 3,
          centeredSlides: true,
          initialSlide :1,
          spaceBetween: 40,
          // loopAdditionalSlides: 0,
          observer:true,//修改swiper自己或子元素时，自动初始化swiper
          observeParents:true,//修改swiper的父元素时，自动初始化swiper
        })
        const swiper2 = new Swiper(".mySwiper2", {
          slidesPerView: 4,
          observer:true,//修改swiper自己或子元素时，自动初始化swiper
          observeParents:true,//修改swiper的父元素时，自动初始化swiper
        })
      }, 500)
    }, [])

    return (
      <React.Fragment>
        <div className="light-show">
          <img className='light-show-img' src={mapBg1}/>
          <div className="swiper mySwiper">
            <div className="swiper-wrapper">
              <div className="swiper-slide">
                <div 
                  className='mask' 
                  // style={{backgroundColor: 'rgba(0, 0, 0,' + (videoObj?1-videoObj.programMediaWallVideoDTOList[0].screenOpacityList[0]/100:null) +')'}}
                ></div>
                {
                  leftVideo ? (
                    <video
                      autoPlay
                      muted
                      loop
                      controls
                      src={leftVideo ? leftVideo : ''}
                      className="light-video"
                    />) : (<img src={defaultPicture}/>)
                }
              </div>
              <div className="swiper-slide">
                <div 
                  className='mask' 
                  // style={{backgroundColor: 'rgba(0, 0, 0,' + (videoObj?1-videoObj.programMediaWallVideoDTOList[0].screenOpacityList[0]/100:null) +')'}}
                ></div>
                {
                  centerVideo ? (
                    <video
                      autoPlay
                      muted
                      loop
                      controls
                      src={centerVideo}
                      className="light-video"
                    />) : (<img src={defaultPicture}/>)
                }
              </div>
              <div className="swiper-slide">
                <div 
                  className='mask' 
                  // style={{backgroundColor: 'rgba(0, 0, 0,' + (videoObj?1-videoObj.programMediaWallVideoDTOList[0].screenOpacityList[0]/100:null) +')'}}
                ></div>
                {
                  rightVideo ? (
                    <MonitorItem
                      url={rightVideo ? rightVideo : ''}
                      accessToken={monitorList[0] ? monitorList[0].monitorAccessToken : ''}
                    />
                  ) : (<img src={defaultPicture}/>)
                }
              </div>
            </div>
          </div>
          <div className='light-bottom'>
            <div className='light-menu'>
              <img
                className='light-menu-bg'
                src={lightBtnVideoBg}
              />
              <div
                className='light-menu-choose'
                onClick={() => {setAddProgramVisible(true)}}
              >
                <img
                  className='light-menu-chooseImg'
                  src={lightChoose}
                />
                <div className='light-menu-chooseText'>编辑节目</div>
              </div>
              <div className='light-list'>
                {
                  pgShowList.map((item, index) => (
                    <div className='light-nameList'>{repairNum(index+1)}/ {item.name}</div>
                  ))
                }
              </div>
            </div>
            <div className="swiper2 mySwiper2">
              <div className="swiper-wrapper">
                {
                  pgShowList.map((item, index) => (
                    <div 
                      className="swiper-slide" 
                      onClick={() => {
                        if (index === currentPlayPgIndex) return pausePlatPg(index, item)
                        playpro(index, item, 1)
                        setTimeout(() => {
                          swiper = null
                          swiper = new Swiper(".mySwiper", {
                            loop: true,
                            slidesPerView: 3,
                            centeredSlides: true,
                            initialSlide :1,
                            spaceBetween: 40,
                            loopAdditionalSlides: 0,
                            observer:true,//修改swiper自己或子元素时，自动初始化swiper
                            observeParents:true,//修改swiper的父元素时，自动初始化swiper
                          })
                        }, 300)
                      }}
                    >
                      <img
                        className='light-menu-bg'
                        src={lightBtnVideoBg}
                      />
                      {
                        index === playType ? (
                          <div className="pg-active-con">
                            <div>当前选择播放</div><br/>
                            <div>节目亮度:{item.programMediaWallVideoDTOList[0].screenOpacityList[0]}</div>
                          </div>
                        ) : (
                          <img
                            className='light-img'
                            src={item.coverBannerUrl}
                          />
                        )
                      }
                      <div className='light-name'>{repairNum(index+1)}/ {item.name}</div>
                    </div>
                  ))
                }
              </div>
            </div>
          </div>
        </div>
        <img className='lightJump' src={lightJump} onClick={() => {window.location.href= "http://" + window.location.hostname + ":20005/manage/light/programManagement"}}/>
        <AddProgram
          visible={addProgramVisible}
          switchVisible={setAddProgramVisible}
          pgList={pgList}
          getProgramList={getProgramList}
        />
      </React.Fragment>
    )
  })
)

export default CockpitLightControl